module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('mt-header', {
    staticStyle: {
      "height": "8vh",
      "font-size": "18px"
    },
    attrs: {
      "title": "注册"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/passport/login"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content_wrap"
  }, [_c('div', {
    ref: "minContent",
    staticClass: "content"
  }, [_c('div', {
    ref: "part_two",
    staticClass: "part_two"
  }, [_c('div', {
    staticClass: "chooseRole"
  }, [_c('div', {
    staticClass: "chooseRole-choose"
  }, [_c('div', {
    class: {
      'identity': true, 'activeIdentity': !_vm.activeIdentity
    },
    on: {
      "click": function($event) {
        return _vm.chooseIdentity(0)
      }
    }
  }, [_c('div', [_vm._v("我是雇主")]), _vm._v(" "), _c('div', [_vm._v("我要找人办事")])]), _vm._v(" "), _c('div', {
    class: {
      'identity': true, 'activeIdentity': _vm.activeIdentity
    },
    on: {
      "click": function($event) {
        return _vm.chooseIdentity(1)
      }
    }
  }, [_c('div', [_vm._v("我是服务商")]), _vm._v(" "), _c('div', [_vm._v("我要入驻赚钱")])])])]), _vm._v(" "), _c('form', {
    staticClass: "from_group",
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateSubmitTwo('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "input_group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|phone'),
      expression: "'required|phone'"
    }],
    ref: "phone",
    class: {
      'input': true, 'is-danger': _vm.errors.has('phone')
    },
    attrs: {
      "pattern": "[0-9]*",
      "type": "tel",
      "name": "phone",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }, _vm.phoneChange]
    }
  }), _vm._v(" "), _c('button', {
    ref: "getCode",
    class: {
      'sendCode': true, 'sendCodeDisable': _vm.sendCodeDisable, 'is-danger': _vm.errors.has('phone')
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.countDown()
      }
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.phone')),
      expression: "errors.has('form-2.phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.phone')))]), _vm._v(" "), _c('div', {
    staticClass: "jisu",
    attrs: {
      "id": "captcha"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input_group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "code",
    class: {
      'input': true, 'is-danger': _vm.errors.has('code')
    },
    attrs: {
      "pattern": "[0-9]*",
      "type": "number",
      "id": "codeVal",
      "name": "code",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, _vm.codeChange]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.code')),
      expression: "errors.has('form-2.code')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.code')))]), _vm._v(" "), _c('div', {
    staticClass: "input_group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|password'),
      expression: "'required|password'"
    }],
    ref: "pw",
    class: {
      'input': true, 'is-danger': _vm.errors.has('password')
    },
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "请设置密码，6-16位数字或字母"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, _vm.passwordChange]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.password')),
      expression: "errors.has('form-2.password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.password')))]), _vm._v(" "), _c('div', {
    staticClass: "submitPart"
  }, [_c('button', {
    staticClass: "register",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dis
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('div', {
    staticClass: "agree"
  }, [_c('span', [_vm._v("注册代表您已同意")]), _vm._v(" "), _c('span', {
    staticClass: "agreement",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("《用户协议》")])])])])]), _vm._v(" "), _c('mt-popup', {
    attrs: {
      "position": "right",
      "id": "alert"
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('div', [_c('mt-header', {
    attrs: {
      "title": "用户协议"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAlert($event)
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('pre', {
    ref: "contract",
    staticClass: "contract"
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-693d60cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/register.vue
// module id = 1283
// module chunks = 1